module.exports = __webpack_public_path__ + "static/media/contact.264d0a50.jpg";